import axios from "../../utils/axiosInstance";

export const getPlaylistCount = async (playlistId: string) => {
    try {
        if (!playlistId) return null;
        const result = await axios.get(
            `${process.env.BASE_URL}api/v1/cms/playlist/counts?playlistId=${playlistId}`
        );
        if (result.data?.success) {
            return result.data?.data?.count;
        } else {
            return null;
        }
    } catch (error) {
        console.log(error);
        return null;
    }
};
